export default "__VITE_ASSET__C4Mg93G___"